import { connect } from 'react-redux';
import StabilityAndGrowthOfPaymentsRawData, {
  Props,
} from '../components/StabilityAndGrowthOfPaymentsRawData';
import { getStabilityAndGrowthOfPaymentsRawDataSelector } from '../redux/selectors';

const mapStateToProps = (state, ownProps): Props =>
  getStabilityAndGrowthOfPaymentsRawDataSelector(state, ownProps);

export default connect(mapStateToProps)(StabilityAndGrowthOfPaymentsRawData);
